import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { useState, useCallback } from 'react';

export default function RoomLocation({data}) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyA6ZOsUuzGxXJoYzuywYFeL37Gy2YHMcuU',
  });

  const containerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '30px'
  }
  
  const center = {
    lat: Number(data.coords_lat),
    lng: Number(data.coords_lng),
  }

  const [map, setMap] = useState(null)

  const onLoad = useCallback(function callback(map) {
    setMap(map)
  }, [])

  const onUnmount = useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      onLoad={onLoad}
      onUnmount={onUnmount}
      className="google-map"
    >
      <Marker position={center}/>
      <></>
    </GoogleMap>
  ) : (
    <></>
  )
};